import styled from "styled-components"

export const UserAvatarContainer = styled.div`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
`
export const UserAvatarImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  border: 1px solid rgba(0, 0, 0, 0.05);
`
